export default "__VITE_ASSET__BZIfHUNp__"